import { WebServices } from '../WebServices';

export async function fetchLID(pdb, sdf, params) {
    const data = await WebServices.startWsRequestJson(WebServices.LID_URL, {
        pdb,
        sdf,
        params,
    });
    const result = JSON.parse(data);
    return result;
}
